import { __cContactService } from '@/services/client/__c.contact.service'
import { useMutation } from '@tanstack/react-query'

export const useContactMutation = () => {
  return useMutation({
    mutationKey: ['mutation.contact'],
    mutationFn: __cContactService.sendContact,
  })
}
